const servicesData = [
  {
    id: "brand",
    icon: "🎯",
    title: "Brand & Identity",

    description:
      "Stop losing deals to unprofessional perception. Build a brand that commands trust, attracts premium clients, and increases revenue by 23%",
    // price: "₦500K",
    details: [
      "✓ Logo (primary, secondary, icon)",
      "✓ Color palette & style guide",
      "✓ Typography system",
      "✓ Brand strategy & guidelines document",
      "✓ Business cards with QR code",
      "✓ Complete brand guidelines PDF",
      "🎁 Bonus: 2 custom-branded T-shirts (FREE)",
    ],
    color: "#1FCF9F",
    button: "Brand & Identity",
  },
  {
    id: "software",
    icon: "💻",
    title: "Software Development",
    description:
      "Custom software that fixes your operations—and multiplies your revenue. Your business runs on paper. Your competitors run on software.",
    // price: "₦1M - ₦100M+",
    details: [
      "✓ Web & mobile apps",
      "✓ Fintech solutions & payment integrations",
      "✓ BNPL & wallet systems",
      "✓ E-commerce platforms",
      "✓ API development & integration",
      "✓ Progressive Web Apps (PWAs)",
      "✓ Admin & reconciliation dashboards",
      "🎁 Bonus: Search engine optimization (FREE)",
    ],
    color: "#FF6B6B",
    button: "Software Dev",
  },
  {
    id: "ai",
    icon: "🤖",
    title: "AI & Automation",
    description:
      "Stop paying staff to copy data, chase approvals, or file receipt→ Our AI automates invoicing, customer replies, report generation, inventory alerts, and more—so your team focuses on growth, not grunt work.",
    // price: "₦5M - ₦500M",
    details: [
      "✓ Automated document processing (invoices, receipts, forms)",
      "✓ Custom AI workflow engineering",
      "✓Inventory prediction and management",
      "✓ Chatbot customer support systems",
      "✓ AI content generation",
      "✓ Predictive analytics",
      "✓ Virtual assistant management",
      "✓ Data extraction and reporting automation",
      "✓ AI-powered legal & contract review",
    ],
    color: "#4ECDC4",
    button: "AI & Automation",
  },
  {
    id: "transform",
    icon: "🚀",
    title: "Digital Transformation",
    description:
      "Your competitors are automating and digitizing. Your customers expect more. Are you ready? We turn operational chaos into a single, scalable, audit-ready system—so you grow without breaking.",
    // price: "₦10M - ₦100M+",
    details: [
      "✓ Business process digitization",
      "✓ Legacy system modernization",
      "✓ ERP/CRM implementation",
      "✓ Cloud migration (AWS, Azure)",
      "✓ Data migration & integration",
      "✓ Workflow automation",
      "✓ Internal tools & dashboards",
    ],
    color: "#FFD93D",
    button: "Digital Transformation",
  },
  {
    id: "ux",
    icon: "✨",
    title: "UI/UX Design",
    description:
      "Great tech fails when real humans can’t use it. We don’t just design scree—we design more paying users",
    // price: "₦1M - ₦20M",
    details: [
      "✓ UX research & user interviews",
      "✓ Wireframing & prototyping (Figma)",
      "✓ Design systems & UI kits",
      "✓ Usability audits",
      "✓ Conversion rate optimization",
      "✓ Product experience design",
      "✓ Mobile app design",
    ],
    color: "#A8E6CF",
    button: "UI/UX Design",
  },
  {
    id: "data",
    icon: "📊",
    title: "Data & Analytics",
    description:
      "Your competitors aren’t smarter—they just see the numbers faster. We turn your scattered data into insight, insight into action and action into impact.",
    // price: "₦3M - ₦50M",
    details: [
      "✓ Business intelligence (BI)",
      "✓ Custom dashboards (Power BI, Tableau)",
      "✓ Data visualization & reporting",
      "✓ Predictive analytics",
      "✓ DHIS2 / LamisPlus customization",
      "✓ Monitoring & evaluation systems",
      "✓ Executive dashboards",
    ],
    color: "#C7CEEA",
    button: "Data & Analytics",
  },
  {
    id: "marketing",
    icon: "📈",
    title: "Digital Marketing",
    description:
      "Your competitors aren’t better—they’re just visible. Are you? Turn your website from a digital brochure into a 24/7 salesperson.",
    // price: "₦200K - ₦2M/month",
    details: [
      "✓ SEO & performance optimization",
      "✓ Social media campaigns",
      "✓ Content marketing strategy",
      "✓ PPC campaign management",
      "✓ Email & funnel automation",
      "✓ WhatsApp Business API",
      "✓ Conversion rate optimization",
    ],
    color: "#FFDAB9",
    button: "Digital Marketing",
  },
  {
    id: "security",
    icon: "🔐",
    title: "Cybersecurity",
    description: "Protect your digital assets and ensure compliance",

    details: [
      "✓ Security audits & assessments",
      "✓ NDPR compliance consulting",
      "✓ Incident response planning",
      "✓ Security training for employees",
      "✓ Data protection strategy",
      "✓ Compliance monitoring",
      "✓ Vulnerability assessments",
    ],
    color: "#B19CD9",
    button: "Cybersecurity",
  },
  {
    id: "hardware",
    icon: "🖥️",
    title: "Digital Hardware & Equipment",
    description:
      "Get business-grade hardware delivered, configured & ready to use. Stop wasting time shopping—we source, setup, and support everything you need to run digitally",
    details: [
      "✓ Business laptops & desktop computers",
      "✓ POS systems & touchscreen tablets",
      "✓ Barcode scanners (handheld & fixed)",
      "✓ Barcode & label printers (thermal)",
      "✓ Receipt printers (POS thermal printers)",
      "✓ Cash drawers (electronic & manual)",
      "✓ Card payment terminals (POS machines)",
      "✓ Network equipment (routers, switches, access points)",
      "✓ UPS & backup power solutions",
      "✓ Security cameras & surveillance systems",
      "✓ Biometric devices (fingerprint, facial recognition)",
      "✓ Digital signage displays",
      "✓ External storage & backup drives",
      "✓ Webcams & conferencing equipment",
      "✓ Headsets & communication devices",
      "🎁 Bonus: FREE installation & configuration support",
    ],
    color: "#FF9A76",
    button: "Hardware & Equipment",
  },
  {
    id: "consulting",
    icon: "🎓",
    title: "IT Consulting & Training",
    description:
      "Bridge the skills gap in your organization. We provide expert IT consulting and hands-on training to help your team master the tools and technologies that drive modern business.",
    details: [
      "✓ IT strategy & roadmap development",
      "✓ Technology stack assessment",
      "✓ Software training (Microsoft 365, Google Workspace)",
      "✓ Custom corporate training programs",
      "✓ Developer & technical team upskilling",
      "✓ Digital literacy workshops",
      "✓ Project management training (Agile, Scrum)",
      "✓ Cybersecurity awareness training",
      "✓ Data analysis & Excel mastery",
      "✓ CRM & ERP system training",
      "🎁 Bonus: Post-training support & resources",
    ],
    color: "#6C5CE7",
    button: "IT Consulting & Training",
  },
  {
    id: "power",
    icon: "⚡",
    title: "Power Solutions",
    description:
      "Reliable power is the backbone of digital operations. We provide complete power solutions to keep your business running 24/7, from solar systems to UPS and generators.",
    externalLink: "https://solar.figodigitalservice.com/",
    details: [
      "✓ Solar Power Backup System",
      "✓ Power Inverter Solution",
      "✓ Battery Power Backup System",
      "✓ Uninterruptible Power Supply (UPS) Solutions",
      "✓ Standby Power Generator",
      "✓ Smart Power Management Systems",
      "✓ Energy Monitoring & Analytics",
      "✓ Power Surge Protection",
      "✓ Automatic Transfer Switch (ATS) Installation",
      "✓ Hybrid Power Systems",
      "✓ Power Infrastructure Assessment",
      "🎁 Bonus: FREE power audit & consultation",
    ],
    color: "#F59E0B",
    button: "Power Solutions",
  },
];

export default servicesData;
